
import { trackLoginImpression } from "@/plugins/hwtag/events";
import { notifyApiErrorMsg } from "@/utils/blockUser";

export default {
  props: ["source", "category"],
  computed: {
    currentUid() {
      return this.$store.state.userInfo?.userInfo?.uid || "";
    },
    /** 两个字段都有就显示已编辑*/
    showEditedMark() {
      const source = this.source
      return Boolean(source && source.edited_time && source.edited_label)
    },
  },
  methods: {
    thumbnailMouseover(index) {
      this.$store.commit("SET_CAROUSEL_index", index);
    },
    /**
     * 未登录时打开登录弹窗,并把"来源信息"透传给弹窗,
     * 这样用户在弹窗里切到 Sign up tab 时会自动上报对应的 reg_trigger 埋点。
     */
    openLoginWithSource(source) {
      const useNewLogin =
        this.$store.state.siteConfig &&
        this.$store.state.siteConfig.DialogPassportSwitch == "1";
      if (useNewLogin) {
        this.$store.commit('OPEN_AUTH_MODAL', { tab: 'login', redirectToUserCenter: false, source });
      } else {
        this.$jumpTerminus(1);
      }
    },
    async likeOperation() {
      if (!this.$store.state.isLogin) {
        const loginChannel = this.category == 1 ? "作品互动" : "讨论帖互动";
        trackLoginImpression("点击", "深度互动", "Like", {}, loginChannel);
        this.openLoginWithSource({
          elementTypeName: "深度互动",
          clickName: "Like",
          loginChannel,
        });
        return;
      }
      //点赞 取消点赞
      // type 1是作品点赞、取消点赞 20是教程点赞、取消点赞 7作品评论点赞、取消点赞 8教程咨询评论点赞、取消点赞 21帖子点赞 取消点赞 22 帖子评论点赞 取消点赞
      let res = await this.$global.likeaction({
        relation_id: this.source.id,
        type: this.category == 1 ? 1 : 21,
      });
      if (res.code == 200) {
        this.source.is_like = res.data.hasClick;
        // this.galleryDetails()
        this.$message({
          showClose: true,
          message: res.msg,
        });
        if (this.source.is_like == 1) {
          /** hwtag埋点-点赞*/
          this.$track("content_liked", {
            content_id: this.source.id,
            content_type: this.category == 1 ? "gallery" : "discussion",
            author_id: this.source.uid,
            author: this.source.nickname,
            current_like: this.source.like_num,
          });
        }
      } else {
        notifyApiErrorMsg(res, this)
      }
    },
    async collectOperation() {
      if (!this.$store.state.isLogin) {
        const loginChannel = this.category == 1 ? "作品互动" : "讨论帖互动";
        trackLoginImpression("点击", "深度互动", "Collect", {}, loginChannel);
        this.openLoginWithSource({
          elementTypeName: "深度互动",
          clickName: "Collect",
          loginChannel,
        });
        return;
      }
      //收藏 取消收藏
      //type 1作品收藏 3资讯收藏 5活动收藏 9帖子收藏 10教程收藏
      //is_collect 0是收藏1取消收藏
      this.followLoading = true;
      let res = await this.$global.do_collect({
        relation_id: this.source.id,
        type: this.category == 1 ? 1 : 9,
        is_collect: this.source.is_collect,
      });
      console.log(res, "res");
      if (res.code == 200) {
        this.source.is_collect = !this.source.is_collect;
        this.$message({
          showClose: true,
          message: res.msg,
        });
        if (this.source.is_collect == 1) {
          /** hwtag埋点-收藏*/
          this.$track("content_collected", {
            content_id: this.source.id,
            content_type: this.category == 1 ? "gallery" : "discussion",
            author_id: this.source.uid,
            author: this.source.nickname,
            current_collect: this.source.collect_num,
          });
        }
      } else {
        notifyApiErrorMsg(res, this)
      }

      this.followLoading = false;
    },
    async focusOn(id) {
      if (!this.$store.state.isLogin) {
        const loginChannel = this.category == 1 ? "gallery" : "论坛帖子详情";
        trackLoginImpression("点击", "用户", "follow", {}, loginChannel);
        this.openLoginWithSource({
          elementTypeName: "用户",
          clickName: "follow",
          loginChannel,
        });
        return;
      }
      //关注用户
      let res = await this.$global.doFollow({ fid: id });
      if (res.code == "200") {
        this.source.is_follow_author = 1
        this.$message(res.msg)
        return
      }
      notifyApiErrorMsg(res, this)
    },
    async unsubscribe(id) {
      //取消关注用户
      let res = await this.$global.unFollow({ fid: id });
      if (res.code == "200") {
        this.source.is_follow_author = 0
        this.$message(res.msg)
        return
      }
      notifyApiErrorMsg(res, this)
    },
    shareExternalLink(type) {
      //1是分享到Facebook 2是分享到twitter
      let code = "" + (parseInt(Math.random() * 10000000) + 10000000);
      code = code.substring(1, 9);

      switch (type) {
        case 1:
          window.open(
            `http://www.facebook.com/sharer.php?u=${window.location.href}?random=${code}`
          );
          break;
        case 2:
          window.open(
            `https://twitter.com/intent/tweet?url=${window.location.href}?random=${code}`
          );
          break;
      }
      /** hwtag埋点-分享*/
      this.$track("share", {
        content_id: this.source.id,
        content_type: this.category == 1 ? "gallery" : "discussion",
        author_id: this.source.uid,
        author: this.source.nickname,
        social_type: type == 2 ? "X" : "facebook",
      });
    },
    jumpStore(url) {
      url != "" ? window.open(url) : "";
    },
  },
};
